module.exports = __webpack_public_path__ + "static/img/img_print_extrato.e230a52.png";


//////////////////
// WEBPACK FOOTER
// ./static/hotpages/promo-so-falta-sua-empresa/img_print_extrato.png
// module id = 1846
// module chunks = 1